import { useLazyQuery } from "@apollo/client";
import { Button } from "../../../../components/ui";
import { FETCH_WAREHOUSE_ITEMS_V2 as fetchWarehouseItemsV2 } from "../../../../graphql/query/WarehouseItem";

const CopyWarehouseDescription = ({ closeModal, instanceId, instance }) => {
  const [fetchWarehouseItems, { loading }] = useLazyQuery(
    fetchWarehouseItemsV2({
      // WarehouseItem scalar fields
      dimh: true,
      dimw: true,
      dimd: true,
      // WarehouseItem associations
      category: {
        description: true
      },
      instance: {
        name: true,
        editionNumber: true,
        edition: {
          number: true,
          year: true,
          artwork: {
            artists: {
              name: true
            },
            title: true,
            medium: true,
            dimensions: true,
          },
        },
      },
      itemSite: {
        location: {
          description: true
        },
        site: {
          name: true
        },
      },
    }),
    {
      variables: {
        input: {
          _instance: {
            id: {
              operator: "eq",
              value: instanceId || instance?.id,
            },
          },
        },
      },
    },
  );

  const formatWarehouseDescription = warehouseItems => {
    return warehouseItems
      .map(item => {
        const lines = [];

        // Storage#
        lines.push(item.id || "");

        // Category
        lines.push(item.category?.description || "");

        // Dimensions on warehouse tab
        const warehouseDimensions = `${item.dimh || "0"} x ${item.dimw || "0"} x ${item.dimd || "0"} cm`;
        lines.push(warehouseDimensions);

        // Artist
        const artists = item.instance?.edition?.artwork?.artists || [];
        const artistNames = artists.map(artist => artist.name).join(", ");
        lines.push(artistNames);

        // Title
        lines.push(item.instance?.edition?.artwork?.title || "Xdd");

        // Year
        lines.push(item.instance?.edition?.year || "");

        // Edition
        if (item.instance?.edition?.number > 1) {
          lines.push(
            `${item.instance?.editionNumber}/${item.instance?.edition?.number}`,
          );
        }

        // Medium
        lines.push(item.instance?.edition?.artwork?.medium || "");

        // Dimensions (artwork dimensions)
        lines.push(item.instance?.edition?.artwork?.dimensions || "");

        // Name
        lines.push(item.instance?.name || "");

        // ID
        lines.push(item.instance?.id ? "ID" + item.instance?.id : "");

        return lines.join("\n");
      })
      .join("\n\n"); // Additional line break between multiple descriptions
  };

  const handleCopyWarehouseDescription = async () => {
    const { data } = await fetchWarehouseItems();
    const warehouseItems = data?.warehouseItemsV2?.edges || [];

    if (warehouseItems.length === 0) {
      closeModal();
      return;
    }

    const formattedDescription = formatWarehouseDescription(warehouseItems);
    await navigator.clipboard.writeText(formattedDescription);
    closeModal();
  };

  return (
    <div className="mt-4 flex">
      <Button
        className="mr-3"
        label={"Cancel"}
        action={"default"}
        onClick={() => {
          closeModal?.();
        }}
      />
      <Button
        disabled={loading}
        loading={loading}
        label={"Copy Warehouse Description"}
        onClick={handleCopyWarehouseDescription}
      />
    </div>
  );
};

export default CopyWarehouseDescription;
